document.addEventListener('DOMContentLoaded', function () {

    function setCookie() {
        const popupElement = document.querySelector('.popup:not(.popup--header)');
        if (!popupElement) return;

        if (!checkCookie()) {
            const days = document.querySelector('.popup:not(.popup--header)').getAttribute('data-inactive');
            document.cookie = `popup=inactive; path=/; max-age=${60 * 60 * 24 * days};`;
            addPopupClass();
        }
    }

    function checkCookie() {
        return document.cookie.split(';').some((item) => item.trim().startsWith('popup=inactive'));
    }

    function addPopupClass() {
        const popupElement = document.querySelector('.popup:not(.popup--header)');
        if (popupElement && !popupElement.classList.contains('popup--inactive')) {
            popupElement.classList.add('popup--inactive');
        }
    }

    function hidePopup() {
        if (checkCookie()) {
            addPopupClass();
        }
    }

    const closeButton = document.querySelector('.popup__close');
    if (closeButton) {
        closeButton.addEventListener('click', function () {
            setCookie();
        });
    }

    const popupLinks = document.querySelectorAll('.popup__link');
    if (popupLinks.length > 0) {
        popupLinks.forEach((popupLink) => {
            popupLink.addEventListener('click', function () {
                setCookie();
            });
        });
    }

    hidePopup();
});
